var Highcharts = require('highcharts');

/**
 * Stores all of the charts to be rendered on the Fund Listing page
 */
window.feCharts = {
    loadedCharts: [],
    currentChart: {
        chartTitle: "",
        dataSet: [],
        seriesName: "",
        color: "",
        xAxisTitle: "",
        yAxisTitle: "",
        tooltipSuffix: ""
    },

    translationKeys: {
        Performance: "_FundlistingEU.Chart.Performance",
        PremiumOrDiscount: "_FundlistingEU.Chart.PremiumOrDiscount",
        NavChart: "_FundlistingEU.Chart.NavChart",
        PriceChart: "_FundlistingEU.Chart.PriceChart",
        CumulativeChart: "_FundlistingEU.Chart.CumulativeChart",
        HypotheticalGrowthChart: "_FundlistingEU.Chart.HypotheticalGrowthChart",
        DownloadNAVHistory: "_FundlistingEU.Chart.DownloadData",
        CHANGEDATERANGE: "_FundlistingEU.Chart.CHANGEDATERANGE",
        Loading: "_FundlistingEU.Chart.Loading",
        SinceInception: "_FundlistingEU.Chart.SinceInception",
        NoDataForSelectedDateRange: "_FundlistingEU.Chart.NoDataForSelectedDateRange",
        yAxisAccessibilityDescription_1: "_FundlistingEU.Chart.yAxisAccessibilityDescription_1",
        yAxisAccessibilityDescription_2: "_FundlistingEU.Chart.yAxisAccessibilityDescription_2",
        ten_years:  "_FundlistingEU.Chart.10_Years",
        five_years: "_FundlistingEU.Chart.5_Years",
        three_years: "_FundlistingEU.Chart.3_Years",
        one_year: "_FundlistingEU.Chart.1_Year",
        six_months: "_FundlistingEU.Chart.6_Months",
        three_months: "_FundlistingEU.Chart.3_Months",
        SelectDateRange: "_FundlistingEU.Chart.SelectDateRange",
        Go: "_FundlistingEU.Chart.Go",

        January: "_FundlistingEU.Chart.Date.January",
        February: "_FundlistingEU.Chart.Date.February",
        March: "_FundlistingEU.Chart.Date.March",
        April: "_FundlistingEU.Chart.Date.April",
        May: "_FundlistingEU.Chart.Date.May",
        June: "_FundlistingEU.Chart.Date.June",
        July: "_FundlistingEU.Chart.Date.July",
        August: "_FundlistingEU.Chart.Date.August",
        September: "_FundlistingEU.Chart.Date.September",
        October: "_FundlistingEU.Chart.Date.October",
        November: "_FundlistingEU.Chart.Date.November",
        December: "_FundlistingEU.Chart.Date.December",

        ShortJan: "_FundlistingEU.Chart.Date.Short.Jan",
        ShortFeb: "_FundlistingEU.Chart.Date.Short.Feb",
        ShortMar: "_FundlistingEU.Chart.Date.Short.Mar",
        ShortApr: "_FundlistingEU.Chart.Date.Short.Apr",
        ShortMay: "_FundlistingEU.Chart.Date.Short.May",
        ShortJun: "_FundlistingEU.Chart.Date.Short.Jun",
        ShortJul: "_FundlistingEU.Chart.Date.Short.Jul",
        ShortAug: "_FundlistingEU.Chart.Date.Short.Aug",
        ShortSep: "_FundlistingEU.Chart.Date.Short.Sep",
        ShortOct: "_FundlistingEU.Chart.Date.Short.Oct",
        ShortNov: "_FundlistingEU.Chart.Date.Short.Nov",
        ShortDec: "_FundlistingEU.Chart.Date.Short.Dec",

        Sunday: "_FundlistingEU.Chart.Date.Sunday",
        Monday: "_FundlistingEU.Chart.Date.Monday",
        Tuesday: "_FundlistingEU.Chart.Date.Tuesday",
        Wednesday: "_FundlistingEU.Chart.Date.Wednesday",
        Thursday: "_FundlistingEU.Chart.Date.Thursday",
        Friday: "_FundlistingEU.Chart.Date.Friday",
        Saturday: "_FundlistingEU.Chart.Date.Saturday"
    },

    translations: {},

    setHighchartsTranslations() {
        Highcharts.setOptions({
            lang: {
                months: [
                    window.feCharts.translations[window.feCharts.translationKeys.January],
                    window.feCharts.translations[window.feCharts.translationKeys.February],
                    window.feCharts.translations[window.feCharts.translationKeys.March],
                    window.feCharts.translations[window.feCharts.translationKeys.April],
                    window.feCharts.translations[window.feCharts.translationKeys.May],
                    window.feCharts.translations[window.feCharts.translationKeys.June],
                    window.feCharts.translations[window.feCharts.translationKeys.July],
                    window.feCharts.translations[window.feCharts.translationKeys.August],
                    window.feCharts.translations[window.feCharts.translationKeys.September],
                    window.feCharts.translations[window.feCharts.translationKeys.October],
                    window.feCharts.translations[window.feCharts.translationKeys.November],
                    window.feCharts.translations[window.feCharts.translationKeys.December],
                ],
                shortMonths: [
                    window.feCharts.translations[window.feCharts.translationKeys.ShortJan],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortFeb],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortMar],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortApr],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortMay],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortJun],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortJul],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortAug],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortSep],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortOct],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortNov],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortDec],
                ],
                weekdays: [
                    window.feCharts.translations[window.feCharts.translationKeys.Sunday],
                    window.feCharts.translations[window.feCharts.translationKeys.Monday],
                    window.feCharts.translations[window.feCharts.translationKeys.Tuesday],
                    window.feCharts.translations[window.feCharts.translationKeys.Wednesday],
                    window.feCharts.translations[window.feCharts.translationKeys.Thursday],
                    window.feCharts.translations[window.feCharts.translationKeys.Friday],
                    window.feCharts.translations[window.feCharts.translationKeys.Saturday],
                ]
            }
        });
    },

    /**
 * Renders the basic chart skeleton, but not the chart.
 *
 * @param {any} chartType
 * @param {any} row
 */
    rnChartArea: function (chartType, row, tickerGroup, displayTicker, invType) {
        //Pass a display ticker when the Fund Ticker being displayed is different from the actual Fund Ticker being passed to the Chart Data API.
        displayTicker = displayTicker || row.ExpandableContent.Ticker;

        switch (chartType) {
            case "hypothetical":

                var title = window.feCharts.translations[window.feCharts.translationKeys.HypotheticalGrowthChart];
                var chartTitle = displayTicker.replace("UCT", "") + " - " + title.replace("{0}", row.ExpandableContent.CurrencySign);

                var downloadUrl = row.ExpandableContent.DownloadUrl;
                if (invType === "mf") {
                    if (!downloadUrl.endsWith('/')) {
                        downloadUrl += '/';
                    }
                    downloadUrl += "?ticker=" + displayTicker;
                }

                var downloadLink = "<div class='expandable-download-link'><a class='font-weight-normal' href='" + downloadUrl + "'>" + window.feCharts.translations[window.feCharts.translationKeys.DownloadNAVHistory] + "</a></div>";

                var inceptionDate = feCharts.getInceptionDate(row.ExpandableContent.InceptionDate);
                var usFormattedDate = `${inceptionDate.getMonth() + 1}/${inceptionDate.getDate()}/${inceptionDate.getFullYear()}`;

                var periods = feCharts.getPricePeriods(inceptionDate);

                var tabs = '<ul class="tabs__items nav nav-tabs chart-tabs" role="tablist" id="tabs-for-' + row.ExpandableContent.Ticker + '" data-ticker="' + row.ExpandableContent.Ticker + '" data-chart-type="' + chartType + '">';

                periods.forEach(function (e, i) {
                    var isActive = e.id === "sinceInception" ? "active" : "";
                    tabs += '<li class="nav-item nav-' + row.ExpandableContent.Ticker + '"> <a class="nav-link price-period ' + isActive + '" id="' + row.ExpandableContent.Ticker + '-' + e.id + '-tab" data-start-date="' + e.startDate + '" role="tab" aria-selected="false">' + e.name + '</a></li>';
                });

                tabs += '</ul >';

                var datePicker = '<div class="row d-flex justify-content-center"><div class="datepicker" id="daterange-' + row.ExpandableContent.Ticker + '-hypothetical-growth" ><span class="datepicker-date active-date active">(DD/MM/YYYY) - (DD/MM/YYYY)</span><button class="datepicker-btn btn btn-link" data-inception-date="' + usFormattedDate + '" id="date-' + row.ExpandableContent.Ticker + '-hypothetical-growth" data-ticker="' + row.ExpandableContent.Ticker + '" data-chart-type="' + chartType + '" use-translation="true" type="button">' + window.feCharts.translations[window.feCharts.translationKeys.CHANGEDATERANGE] + '</button></div></div>';

                break;
            case "premium-discount":
                var chartTitle = displayTicker + " " + window.feCharts.translations[window.feCharts.translationKeys.PremiumOrDiscount] + ": <span id='current-quarter'></span>";

                var downloadLink = "";

                var tabs = '<ul class="tabs__items nav nav-tabs chart-tabs" role="tablist" id="tabs-for-' + row.ExpandableContent.Ticker + '" data-ticker="' + row.ExpandableContent.Ticker + '" data-chart-type="' + chartType + '">';

                row.ExpandableContent.Quarters.forEach(function (e, i) {
                    tabs += '<li class="nav-item nav-' + row.ExpandableContent.Ticker + '"> <a class="nav-link premium-discount-quarter" id="' + e.Value + '-tab" data-quarter="' + e.Value + '" role="tab" aria-controls="Last11Year" aria-selected="">' + e.Name + '</a></li>';
                });

                tabs += '</ul >';

                var datePicker = ''; //no date picker for premium discount
                break;
            case "price":

                var title = window.feCharts.translations[window.feCharts.translationKeys.NavChart];
                if (typeof tickerGroup === "string") {
                    title = tickerGroup.toLowerCase() === "index" ? window.feCharts.translations[window.feCharts.translationKeys.PriceChart] : title;
                }

                var chartTitle = displayTicker.replace("UCT", "") + " - " + title;

                var downloadLink = invType !== "mf"
                    ? "<div class='expandable-download-link'><a class='font-weight-normal' href='" + row.ExpandableContent.DownloadUrl + "'>" + window.feCharts.translations[window.feCharts.translationKeys.DownloadNAVHistory] + "</a></div>"
                    : "";

                var inceptionDate = feCharts.getInceptionDate(row.ExpandableContent.InceptionDate);
                var usFormattedDate = `${inceptionDate.getMonth() + 1}/${inceptionDate.getDate()}/${inceptionDate.getFullYear()}`;

                var periods = feCharts.getPricePeriods(inceptionDate);

                var tabs = '<ul class="tabs__items nav nav-tabs chart-tabs" role="tablist" id="tabs-for-' + row.ExpandableContent.Ticker + '" data-ticker="' + row.ExpandableContent.Ticker + '" data-chart-type="' + chartType + '">';

                periods.forEach(function (e, i) {
                    var isActive = e.id === "sinceInception" ? "active" : "";
                    tabs += '<li class="nav-item nav-' + row.ExpandableContent.Ticker + '"> <a class="nav-link price-period ' + isActive + '" id="' + row.ExpandableContent.Ticker + '-' + e.id + '-tab" data-start-date="' + e.startDate + '" role="tab" aria-selected="false">' + e.name + '</a></li>';
                });

                tabs += '</ul >';

                var datePicker = '<div class="row d-flex justify-content-center"><div class="datepicker" id="daterange-' + row.ExpandableContent.Ticker + '-prices" ><span class="datepicker-date active-date active">(DD/MM/YYYY) - (DD/MM/YYYY)</span><button class="datepicker-btn btn btn-link" data-inception-date="' + usFormattedDate + '" id="date-' + row.ExpandableContent.Ticker + '-prices" data-ticker="' + row.ExpandableContent.Ticker + '" data-chart-type="' + chartType + '" use-translation="true" type="button">' + window.feCharts.translations[window.feCharts.translationKeys.CHANGEDATERANGE] + '</button></div></div>';

                break;
            case "cumulative":

                var title = window.feCharts.translations[window.feCharts.translationKeys.CumulativeChart];
                var chartTitle = displayTicker.replace("UCT", "") + " - " + title;

                var downloadLink = invType !== "mf"
                    ? "<div class='expandable-download-link'><a class='font-weight-normal' href='" + row.ExpandableContent.DownloadUrl + "'>" + window.feCharts.translations[window.feCharts.translationKeys.DownloadNAVHistory] + "</a></div>"
                    : "";

                var inceptionDate = feCharts.getInceptionDate(row.ExpandableContent.InceptionDate);
                var usFormattedDate = `${inceptionDate.getMonth() + 1}/${inceptionDate.getDate()}/${inceptionDate.getFullYear()}`;

                var periods = feCharts.getPricePeriods(inceptionDate);

                var tabs = '<ul class="tabs__items nav nav-tabs chart-tabs" role="tablist" id="tabs-for-' + row.ExpandableContent.Ticker + '" data-ticker="' + row.ExpandableContent.Ticker + '" data-chart-type="' + chartType + '">';

                periods.forEach(function (e, i) {
                    var isActive = e.id === "sinceInception" ? "active" : "";
                    tabs += '<li class="nav-item nav-' + row.ExpandableContent.Ticker + '"> <a class="nav-link price-period ' + isActive + '" id="' + row.ExpandableContent.Ticker + '-' + e.id + '-tab" data-start-date="' + e.startDate + '" role="tab" aria-selected="false">' + e.name + '</a></li>';
                });

                tabs += '</ul >';

                var datePicker = '<div class="row d-flex justify-content-center"><div class="datepicker" id="daterange-' + row.ExpandableContent.Ticker + '-cumulative" ><span class="datepicker-date active-date active">(DD/MM/YYYY) - (DD/MM/YYYY)</span><button class="datepicker-btn btn btn-link" data-inception-date="' + usFormattedDate + '" id="date-' + row.ExpandableContent.Ticker + '-cumulative" data-ticker="' + row.ExpandableContent.Ticker + '" data-chart-type="' + chartType + '" use-translation="true" type="button">' + window.feCharts.translations[window.feCharts.translationKeys.CHANGEDATERANGE] + '</button></div></div>';

                break;
            default:
                console.error("Unknown chart type:" + chartType);
                return "";
        }

        var chartHeader = '<h4 class="mb-0" id="chart-title-' + row.ExpandableContent.Ticker + '">' + chartTitle + '</h4>' + downloadLink + '<div class="fund-explorer-table__graph row"> <div class="fund-explorer-table__graph-tab col-12"> <div class="tabs">';

        //var tabs is declated above.

        /* We are only rendering one tab and using JS to re-render the chart on the same tab, hence disabling the BS Tabs functionality. */
        var tabContent = '<div class="tabs__content tab-content"> <div class="tab-pane fade active show" id="the-tab-' + row.ExpandableContent.Ticker + '" role="tabpanel"  aria-labelledby="nav-list-' + row.ExpandableContent.Ticker + '"> ' + window.feCharts.translations[window.feCharts.translationKeys.Loading] + ' </div> </div >';

        var headerClose = '</div></div>';



        return chartHeader + tabs + tabContent + headerClose + datePicker;
    },

    getDateParts: function(date) {
        if(date.indexOf('/') !== -1) {
            return date.split('/');
        }

        if(date.indexOf('.') !== -1) {
            return date.split('.');
        }

        if(date.indexOf(' ') !== -1) {
            return date.split(' ');
        }

        if(date.indexOf('-') !== -1) {
            return date.split('-');
        }

        return null;
    },


    getInceptionDate: function(date) {
        const dateParts = feCharts.getDateParts(date);

        if(isNaN(dateParts[1])) {
            const months = {jan:1,feb:2,mar:3,apr:4,may:5,jun:6,jul:7,aug:8,sep:9,oct:10,nov:11,dec:12};
            dateParts[1] = months[dateParts[1].toLowerCase()];
        }

        if(dateParts[2] < 2000) {
            dateParts[2] = '20' + dateParts[2];
        }
        const inceptionDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        return inceptionDate;
    },


    loadData: function(renderContainer, ticker, chartType, quarter, startDate, endDate, noDataText) {
        /**
         * Guard clauses
         */

        if (typeof ticker != "string") return console.error("Can't load chart without ticker.");
        if (typeof chartType != "string") return console.error("Can't load chart without chart type.");
        if (typeof renderContainer != "string") return console.error("Can't load chart without a rendering container.");
        var url = "/Main/FundListingUcits/GetChartData/";
        var mkDates = "";
        var mkQuarter = "";

        switch (chartType) {
        case "premium-discount":
            if (typeof quarter != "string") return console.error("Can't load chart without chart type.");
            mkQuarter = '"Quarter":"' + quarter + '",';
                break;
        case "price":
        case "PriceWithDecimal":
        case "cumulative":
        case "hypothetical":
            if (typeof startDate == "undefined" || typeof endDate == "undefined")
                return console.error("Can't load chart without a starting and ending date.");
            mkDates = '"StartTime":"' + startDate + '","EndTime":"' + endDate + '",';
            break;
        default:
            return console.error("Unknown chart type: " + chartType);
        }

    var mkTicker = '"Ticker":"' + ticker + '",';
        var mkChartType = '"ChartType":"' + chartType + '"';

        /**Payload needs to be in the string format required by Prabhu... */
        var payload = {
            'filterJson':
                "{" + mkTicker + mkDates + mkQuarter + mkChartType + "}"
        }

        //console.log(payload);

        $.post(url, payload).done(function(data, response) {
            if (typeof data.Result != "object" || data.Result.length < 1) return console.error("The response was not expected.");
            feCharts.loadedCharts.push(feCharts.processData(data.Result[0], renderContainer));
            feutils.spinner.hide();
        }).fail(feCharts.ajaxFail);

    },

    ajaxFail: function(e) {
        console.error("The response returned an error!");
        feutils.spinner.hide();
        console.log(e);
    },

    processData: function(data, renderSlr) {
        if (typeof data != "object") return console.error("Chart details expected!");
        if (typeof data.ChartData === "undefined" || data.ChartData.length === 0) {
            /* There is no data */

            $(renderSlr).html('<div class="w-100 text-center text-primary my-6">' + window.feCharts.translations[window.feCharts.translationKeys.NoDataForSelectedDateRange] + '</div>');
            return [];
        }

        var dataSet = [];
        data.ChartData.forEach(function(e, i) {
            var s = e.split(",");
            var date = Date.UTC(s[0], s[1], s[2], 4); /* UTC + 4 hours = ET */
            var val = Number(s[3]);
            val = isNaN(val) ? 0 : val;
            dataSet.push([date, val]);
        });
        var ChartData = {};

        //check if the dataset is less than 3 months
        var startDate = new Date(dataSet[0][0]);
        var endDate = new Date(dataSet[dataSet.length - 1][0]);
        var dateSpan = endDate - startDate;
        dateSpan = dateSpan < 1 ? dateSpan * -1 : dateSpan;
        var smallPeriod = (dateSpan < 1000 * 60 * 60 * 24 * 130); //Approx 130 days

        switch (data.ChartType) {
            case "premium-discount":
                ChartData = {
                    chartTitle: false, //data.Name + " Premium or Discount (bps)",
                    dataSet: dataSet,
                    seriesName: data.Ticker,
                    color: data.Color || "#17468f",
                    xAxisTitle: data.XAxisTitle,
                    yAxisTitle: data.YAxisTitle,
                    tooltipSuffix: "%",
                    tooltipPrefix: "",
                    xAxisLabelFormat: smallPeriod ? "{value: %b %e %Y}" : "{value: %b-%Y}",
                    tooltipFormatter: "price"
                }
                break;
            case "price":
            case "PriceWithDecimal":
            case "cumulative":
            case "hypothetical":
                ChartData = {
                    chartTitle: false, //data.Name + " Premium or Discount (bps)",
                    dataSet: dataSet,
                    seriesName: data.Ticker,
                    color: data.Color || "#17468f",
                    xAxisTitle: data.XAxisTitle,
                    yAxisTitle: data.YAxisTitle,
                    tooltipSuffix: "",
                    tooltipPrefix: data.TooltipPrefix ?? "$",
                    xAxisLabelFormat: smallPeriod ? "{value: %b %e %Y}" : "{value: %b-%Y}",
                    tooltipFormatter: "nav"
                }
                break;
            default:
                return console.error("Unidentified chart type: " + data.ChartType);
        }

        feCharts.currentChart = ChartData;
        return feCharts.rnChart($(renderSlr)[0]);

    },

    activateTabListeners: function() {
        $('ul.chart-tabs').each(function(i, e) {
            var chartType = $(e).data('chart-type');
            var ticker = $(e).data('ticker');

            switch (chartType) {
            case "premium-discount":
                var tabslr = "#tabs-for-" + ticker + " .premium-discount-quarter";
                    $(tabslr).click(function () {
                        feutils.spinner.show();
                        $(this).parent().parent().find('a.nav-link').removeClass('active');
                        $(this).addClass('active');
                    var quarter = $(this).data("quarter");
                    var container = "#the-tab-" + ticker;
                    feCharts.loadData(container, ticker, chartType, quarter, false, false);
                    $('#chart-title-' + ticker + ' > #current-quarter').text(quarter);
                });
                break;
            case "price":
            case "cumulative":
            case "hypothetical":
                //price and cumulative charts is triggered by listening for a datepicker change. see scripts.js
            break;
            default:
                return;
            }
        });

        $('.expandable-content-pane').on('shown.bs.collapse',
            function() {
                var activePriceElem = $(this).find('a.nav-link.price-period.active');
                $(this).find('a.nav-link.premium-discount-quarter').first().click();
                $(this).find('a.nav-link.hypothetical-quarter').first().click();

                $(this).find('.datepicker-btn').trigger('apply.daterangepicker');
                //the first time make the "since inception" active again, regardless of daterangepicker removing it...
                if (activePriceElem.length === 1) {
                    window.setTimeout(function() {
                        activePriceElem.addClass("active");
                    }, 20)
                }
            }).on('hidden.bs.collapse', function() {
            //delete the chart
            $(this).find('.tab-pane.active').first().empty();
        });
    },

    //precision rounding
    mathRound: function(num) {
        var m = Number((Math.abs(num) * 100).toPrecision(15));
        return Math.round(m) / 100 * Math.sign(num);
    },


    rnChart: function (containerElm) {
        var currentChart = feCharts.currentChart;

        return new Highcharts.Chart({
            chart: {
                renderTo: containerElm,
                type: 'line',
                height: 350,
                backgroundColor: "rgba(0, 0, 0, 0)"
            },
            colors: [currentChart.color],
            title: {
                text: currentChart.chartTitle ? currentChart.chartTitle : undefined
            },
            xAxis: {
                lineColor: '#323232',
                labels: {
                    type: 'datetime',
                    format: currentChart.xAxisLabelFormat,
                    enabled: true,
                    style: {
                        fontSize: '11px',
                        color: '#323232'
                    },
                    gridLineWidth: 0
                },
                title: {
                    text: currentChart.xAxisTitle,
                    style: {
                        color: '#323232'
                    }
                }
            },
            yAxis: {
                title: {
                    text: currentChart.yAxisTitle,
                    style: {
                        color: '#323232'
                    }
                },
                accessibility: {
                    description: window.feCharts.translations[window.feCharts.translationKeys.yAxisAccessibilityDescription_1] +
                        $('.hidden_data_feilds').find('.hdnNameClass').val() +
                        window.feCharts.translations[window.feCharts.translationKeys.yAxisAccessibilityDescription_2]
                },
                lineColor: '#323232',
                lineWidth: 1,
                labels: {
                    overflow: 'justify',
                    format: currentChart.tooltipPrefix + '{value}',
                    style: {
                        color: '#323232'
                    }
                }
            },
            tooltip: {
                formatter: function () {
                    var y = currentChart.tooltipPrefix + feCharts.mathRound(this.y).toFixed(2) + currentChart.tooltipSuffix;
                    switch (currentChart.tooltipFormatter) {
                        case "nav":
                            return '<strong>' +
                                this.series.name +
                                '</strong><br/>' +
                                Highcharts.dateFormat('%a, %b %e %Y', this.x) +
                                ' : ' + y;
                        case "price":
                        case "cumulative":
                        default:
                            return '' +
                                this.series.name +
                                ' : ' +
                                Highcharts.dateFormat('%b %e %Y', this.x) +
                                '<br />' +
                                y;
                    }

                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: false
                    }
                },
                series: {
                    marker: false
                }
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                x: -5,
                y: 20,
                floating: false,
                borderWidth: 1,
                backgroundColor: '#FFFFFF',
                shadow: true
            },
            credits: {
                enabled: false
            },
            exporting: false,
            series: [{
                name: currentChart.seriesName,
                data: currentChart.dataSet
    }]
        });
    },

    getPricePeriods: function (inceptionDate) {
        var today = new Date();
        if (typeof inceptionDate != "object" || +inceptionDate > +today){ console.error("Need a valid inception date"); return [];}
        //var diff = today - inceptionDate;
        var periods = [];

        var threeMonths = new Date(new Date().setMonth(new Date().getMonth() - 3));
        var sixMonths = new Date(new Date().setMonth(new Date().getMonth() - 6));
        var oneYear = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
        var threeYear = new Date(new Date().setFullYear(new Date().getFullYear() - 3));
        var fiveYear = new Date(new Date().setFullYear(new Date().getFullYear() - 5));
        var tenYear = new Date(new Date().setFullYear(new Date().getFullYear() - 10));

        switch(true) {
            case (+inceptionDate < +tenYear):
                periods.push({
                    id: "tenYear",
                    name: window.feCharts.translations[window.feCharts.translationKeys.ten_years],
                    startDate: tenYear
                });
            case (+inceptionDate < +fiveYear):
                periods.push({
                    id: "fiveYear",
                    name: window.feCharts.translations[window.feCharts.translationKeys.five_years],
                    startDate: fiveYear
                });
            case (+inceptionDate < +threeYear):
                periods.push({
                    id: "threeYear",
                    name: window.feCharts.translations[window.feCharts.translationKeys.three_years],
                    startDate: threeYear
                });
            case (+inceptionDate < +oneYear):
                periods.push({
                    id: "oneYear",
                    name: window.feCharts.translations[window.feCharts.translationKeys.one_year],
                    startDate: oneYear
                });
            case (+inceptionDate < +sixMonths):
                periods.push({
                    id: "sixMonths",
                    name: window.feCharts.translations[window.feCharts.translationKeys.six_months],
                    startDate: sixMonths
                });
            case (+inceptionDate < +threeMonths):
                periods.push({
                    id: "threeMonths",
                    name: window.feCharts.translations[window.feCharts.translationKeys.three_months],
                    startDate: threeMonths
                });
        }

        periods.reverse();

        const currentLocale = window.feCharts.getCurrentLocale();
        periods.push({
            id: "sinceInception",
            name: window.feCharts.translations[window.feCharts.translationKeys.SinceInception] + inceptionDate.toLocaleDateString(currentLocale),
            startDate: inceptionDate
        });

        return periods;

    },

    getCurrentLocale: function() {
        const [html] = document.getElementsByTagName("html")
        const lang = html.getAttribute("lang");
        return lang;
    },

    getCurrentPathCountryAndLanguage: function() {
        const pathArray = window.location.pathname.split("/");
        if(pathArray.length < 3) {
            return "nl/nl";
        }

        return `${pathArray[1]}\\${pathArray[2]}`;
    }
}